"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderComboPredictionDays = getOrderComboPredictionDays;
exports.getLockAdjustmentForCountryInDays = getLockAdjustmentForCountryInDays;
const constants_1 = require("@daytrip/constants");
const legacy_models_1 = require("@daytrip/legacy-models");
const utils_1 = require("@daytrip/utils");
const LOOSE_COMBO_PREDICTION_DAYS = 22;
const LOOSEN_COMBO_LOCK_FOR_NON_COMBO_COUNTRY_DAYS = 1;
const COMBO_PROTECTED_COUNTRIES = new Set([
    // top 10
    constants_1.ITALY_COUNTRY_ID, // Italy
    constants_1.PORTUGAL_COUNTRY_ID, // Portugal
    "7059c5a4-d6b9-4581-9a02-dff7fd29668d", // Croatia
    "83accacd-8cc5-4060-a13d-fc1c0405ffd6", // Czech Republic
    "3549595a-4474-45a8-945b-ca49b7179013", // France
    "bab891cd-8c85-4579-ad3e-40d576f7c1c7", // Spain
    "0ca4868f-dd41-4a89-8ca8-0febb9fdee33", // Hungary
    "cf0e1ca7-8a62-42b2-b322-d95585f520da", // Netherlands
    "b49e7c76-2671-4072-be6e-1d04ef44ec75", // Ireland
    "456e65d2-d773-400b-8ef1-4ff1fe8c439b", // Germany
    // top 10-20
    "8d39bf1a-5bef-482b-8863-ff39929722e2", // Austria
    "6257ba70-20d4-4cd0-83d4-5c25b0ced4e7", // Switzerland
    "1a1f13c2-5d72-45dd-b6e9-d8ad7a6dc0c8", // Greece
    "07802b4e-4762-4bc1-8bb9-ecc884db2a7e", // Slovenia
    "faa710fc-8763-4142-87a4-fae557f5c791", // Belgium
    "8e6bd218-7900-4f88-952a-2ae28550fcdf", // Mexico
    "2b326870-a0b7-4074-bad7-5843a21c50e0", // Montenegro
    "19ae524a-3871-4575-8785-dbf7afe9b32b", // Malaysia
    "f04473eb-0838-4bf4-8384-81566fcd0c99", // Costa Rica
    "72d0af10-641c-426c-bcc5-fda9f2e247de", // Latvia
    // other
    "dd9c0af8-fe1c-4438-ae59-74517ede0e18", // Thailand
]);
function getOrderComboPredictionDays({ order }) {
    const pricingCountryId = order.pricingCountryId;
    if (!pricingCountryId) {
        return;
    }
    // Orders that are not supported by the combo engine
    if (order.isVIP || (0, legacy_models_1.isAirportTransfer)(order) || !order.travelEstimates) {
        return;
    }
    // Roundtrips
    if (order.originLocationId === order.destinationLocationId) {
        return;
    }
    if ((0, utils_1.isComboPredictedRoute)(order.routeId)) {
        return constants_1.COMBO_PROTECTION_DAYS_THRESHOLD;
    }
    // If the time to get back is long, it is more likely to form a multi-day combo (sleepover is worth it)
    const hasLongWayback = order.travelEstimates.travelTimeWaybackMinutes > 150;
    const countryComboLockAdjustment = getLockAdjustmentForCountryInDays(pricingCountryId);
    const departureAt = new Date(order.departureAt);
    const startHour = departureAt.getUTCHours() + departureAt.getMinutes() / 60;
    const travelHours = order.travelEstimates.travelTimeMinutes / 60;
    if (hasLongWayback || isVeryEarlyMorningOrder(startHour, travelHours) || isAfternoonOrder(startHour, travelHours)) {
        return 22 + countryComboLockAdjustment;
    }
    return LOOSE_COMBO_PREDICTION_DAYS + countryComboLockAdjustment;
}
function isVeryEarlyMorningOrder(startHour, travelHours) {
    const arrivalAtHour = startHour + travelHours;
    const arrivalAtConverted = arrivalAtHour % 24;
    // Prediction is based on most orders starting in the morning hours (8-12)
    // If order happens between 5 and 9 it's likely to form combo with morning orders
    return arrivalAtConverted <= 9 && startHour >= 5 && startHour <= 9;
}
function isAfternoonOrder(startHour, travelHours) {
    // 24 + part is to avoid getting negative values, examples:
    // 24 + 2 - 2 - 3 = 21 - remainder 21
    // 24 + 15 - 2 - 3 = 34 - remainder 10
    // 24 + 17 - 2 - 3 = 36 - remainder 12
    const oppositeDirectionTripIdealStartHour = (24 + startHour - 2 - travelHours) % 24;
    // If order is in the afternoon and the opposite direction trip would be starting in the morning
    return oppositeDirectionTripIdealStartHour >= 9 && oppositeDirectionTripIdealStartHour <= 17;
}
function getLockAdjustmentForCountryInDays(pricingCountryId) {
    const inComboProtectedCountry = COMBO_PROTECTED_COUNTRIES.has(pricingCountryId);
    // In countries with less combo likelihood, unlock the order earlier for better availability in early offers
    return inComboProtectedCountry ? 0 : LOOSEN_COMBO_LOCK_FOR_NON_COMBO_COUNTRY_DAYS;
}
//# sourceMappingURL=getOrderComboPredictionDays.js.map